// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.shortcuts .dialog {
    width: 820px;
    top: 50%;
}

.modal.shortcuts .dialog .titlebar {
    background-color: #2c3a74;
}

.modal.shortcuts .dialog .body {
    padding-top: 6px;
}

.modal.shortcuts .dialog .section {
    border-top: 1px solid var(--black-20);
    padding-top: 10px;
}

.modal.shortcuts .dialog .section:first-of-type {
    border-top: none;
    padding-top: 0;
}

.modal.shortcuts .dialog .section-title {
    color: var(--black-85);
    font-weight: bold;
    font-size: 14px;
    margin: 4px 0 8px 0;
}

.modal.shortcuts .dialog .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 6px 0;
}

.modal.shortcuts .dialog .row .action {
    color: var(--black-65);
}

.modal.shortcuts .dialog .row .keys {
    display: flex;
    gap: 6px;
}

.modal.shortcuts .dialog .row .or {
    color: var(--black-45);
    padding: 0 4px;
}

.keycap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    min-width: 22px;
    padding: 0 8px;
    border-radius: 4px;
    background-color: var(--black-10);
    border: 1px solid var(--black-25);
    color: var(--black-85);
    font-weight: 600;
}

.modal.shortcuts .dialog .footnote {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--black-20);
    color: var(--black-45);
    display: flex;
    align-items: center;
    gap: 6px;
    justify-content: center;
}

.modal.shortcuts .search {
    position: relative;
    margin-bottom: 8px;
}

.modal.shortcuts .search .icon {
    position: absolute;
    top: 6px;
    left: 10px;
    font-size: 20px;
    color: var(--black-45);
    user-select: none;
}

.modal.shortcuts .searchbox {
    margin-top: 2px;
    font-size: 14px;
    width: 100%;
    height: 30px;
    padding: 5px;
    padding-left: 34px;
    color: var(--black-65);
    background-color: var(--black-10);
    border: solid var(--black-15) 1px;
    border-radius: 4px;
    outline: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.modal.shortcuts .searchbox::placeholder { color: var(--black-35); }

.modal.shortcuts .sections {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px 24px;
    min-height: 600px; /* prevent shrink on empty search */
}
 
.modal.shortcuts .no-results {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--black-65);
  padding: 40px 0;
}

@media (min-width: 700px) {
  .modal.shortcuts .dialog { width: 820px; }
  .modal.shortcuts .sections { grid-template-columns: 1fr 1fr; }
}

/* no constant size/no-results styles (rolled back) */
`, "",{"version":3,"sources":["webpack://./src/shortcuts.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;IACjC,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;IACjC,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,2CAA2C,sBAAsB,EAAE;;AAEnE;IACI,aAAa;IACb,0BAA0B;IAC1B,cAAc;IACd,iBAAiB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2BAA2B,YAAY,EAAE;EACzC,6BAA6B,8BAA8B,EAAE;AAC/D;;AAEA,qDAAqD","sourcesContent":[".modal.shortcuts .dialog {\n    width: 820px;\n    top: 50%;\n}\n\n.modal.shortcuts .dialog .titlebar {\n    background-color: #2c3a74;\n}\n\n.modal.shortcuts .dialog .body {\n    padding-top: 6px;\n}\n\n.modal.shortcuts .dialog .section {\n    border-top: 1px solid var(--black-20);\n    padding-top: 10px;\n}\n\n.modal.shortcuts .dialog .section:first-of-type {\n    border-top: none;\n    padding-top: 0;\n}\n\n.modal.shortcuts .dialog .section-title {\n    color: var(--black-85);\n    font-weight: bold;\n    font-size: 14px;\n    margin: 4px 0 8px 0;\n}\n\n.modal.shortcuts .dialog .row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    padding: 6px 0;\n}\n\n.modal.shortcuts .dialog .row .action {\n    color: var(--black-65);\n}\n\n.modal.shortcuts .dialog .row .keys {\n    display: flex;\n    gap: 6px;\n}\n\n.modal.shortcuts .dialog .row .or {\n    color: var(--black-45);\n    padding: 0 4px;\n}\n\n.keycap {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 22px;\n    min-width: 22px;\n    padding: 0 8px;\n    border-radius: 4px;\n    background-color: var(--black-10);\n    border: 1px solid var(--black-25);\n    color: var(--black-85);\n    font-weight: 600;\n}\n\n.modal.shortcuts .dialog .footnote {\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid var(--black-20);\n    color: var(--black-45);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    justify-content: center;\n}\n\n.modal.shortcuts .search {\n    position: relative;\n    margin-bottom: 8px;\n}\n\n.modal.shortcuts .search .icon {\n    position: absolute;\n    top: 6px;\n    left: 10px;\n    font-size: 20px;\n    color: var(--black-45);\n    user-select: none;\n}\n\n.modal.shortcuts .searchbox {\n    margin-top: 2px;\n    font-size: 14px;\n    width: 100%;\n    height: 30px;\n    padding: 5px;\n    padding-left: 34px;\n    color: var(--black-65);\n    background-color: var(--black-10);\n    border: solid var(--black-15) 1px;\n    border-radius: 4px;\n    outline: none;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.modal.shortcuts .searchbox::placeholder { color: var(--black-35); }\n\n.modal.shortcuts .sections {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px 24px;\n    min-height: 600px; /* prevent shrink on empty search */\n}\n \n.modal.shortcuts .no-results {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--black-65);\n  padding: 40px 0;\n}\n\n@media (min-width: 700px) {\n  .modal.shortcuts .dialog { width: 820px; }\n  .modal.shortcuts .sections { grid-template-columns: 1fr 1fr; }\n}\n\n/* no constant size/no-results styles (rolled back) */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
